
import React from 'react';
import { useNavigate } from 'react-router-dom';
import ContattiPersonalizzati from './ContattiPersonalizzati';

function Personalizzato() {
  const navigate = useNavigate();
  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div align="left">
              <h1 className="text-secondary">
                <i className="fas fa-edit me-2"></i>
                Invio Personalizzato
              </h1>
              <p className="text-muted">Importa contatti da Excel o inserisci manualmente, poi componi e invia la mail personalizzata.</p>
            </div>
            <div>
              <button className="btn btn-outline-secondary" onClick={() => navigate('/dashboard')}>
                <i className="fas fa-arrow-left"></i> Torna al Dashboard
              </button>
            </div>
          </div>
        </div>
      </div>
      <ContattiPersonalizzati />
      <div style={{height: '1.5rem'}}></div>
    </div>
  );
}

export default Personalizzato;
